import React from 'react';
import type {ItemFormValues, UseItemForm} from '../../hooks/useItemForm';
import type {ItemFormRefs} from './types';
import {CheckboxField, ChipGroup} from './ItemFormControls';

export interface ItemFormConditionProps {
    values: ItemFormValues;
    refs: ItemFormRefs;
    setField: UseItemForm['setField'];
    toggle: UseItemForm['toggle'];
}

/**
 * Дефекты и защитные свойства. Пустой список дефектов означает «не указаны», а
 * не «дефектов нет» — вывод делает карточка вещи, форма ничего не утверждает.
 */
const ItemFormCondition: React.FC<ItemFormConditionProps> = ({values, refs, setField, toggle}) => (
    <>
        <ChipGroup
            legend="Дефекты"
            testId="item-chips-defects"
            options={refs.defects}
            selected={values.defectIds}
            onToggle={id => toggle('defectIds', id)}
        />
        <CheckboxField
            id="item-waterproof"
            label="Водонепроницаемая"
            checked={values.waterProof}
            onChange={v => setField('waterProof', v)}
        />
    </>
);

export default ItemFormCondition;
